export const setObjectValuesPolyfill = () => {
  if (!Object.values) {
    Object.values = object => Object.keys(object).map(key => object[key])
  }
}